// loaderSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loadingActions: {},
  errorMessages: {}, // Add errorMessages to store error for each API call
};

const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loadingActions[action.payload.action] = true;
    },
    setLoaded: (state, action) => {
      delete state.loadingActions[action.payload.action];
    },
    setError: (state, action) => {
      state.errorMessages[action.payload.action] = action.payload.message;
    },
    clearError: (state, action) => {
      delete state.errorMessages[action.payload.action];
    },
  },
});

export const { setLoading, setLoaded, setError, clearError } = loaderSlice.actions;
export const selectLoaderState = (state) => state.loader;
export default loaderSlice.reducer;
